/**
 * Machine readable causes a domain operation can fail with. The UI maps these
 * to messages; it never parses error text.
 */
export const domainErrorCodes = [
  'TEAM_NAME_TAKEN',
  'REGISTRATION_CLOSED',
  'TOURNAMENT_FULL',
  'SETTINGS_LOCKED',
  'INVALID_PHASE_CONFIG',
  'UNKNOWN_FORMAT',
  'MATCH_NOT_REPORTABLE',
  'NOT_A_PARTICIPANT',
  'RESULT_CONFLICT',
  'PHASE_NOT_COMPLETE',
  'INVALID_STATE_TRANSITION',
] as const;

export type DomainErrorCode = (typeof domainErrorCodes)[number];

/**
 * Raised by the domain layer when a rule is violated. Carries a code rather
 * than only a message so callers can react without string matching.
 */
export class DomainError extends Error {
  readonly code: DomainErrorCode;
  readonly details: Readonly<Record<string, unknown>>;

  constructor(code: DomainErrorCode, message: string, details: Record<string, unknown> = {}) {
    super(message);
    this.name = 'DomainError';
    this.code = code;
    this.details = details;
  }
}

export function isDomainError(error: unknown): error is DomainError {
  return error instanceof DomainError;
}
